// PARA-105 §3/§8.3 / PARA-112 — тонкая обёртка над общим api-client
// (shared/api-client). onUnauthorized регистрируется лениво AuthProvider
// (useEffect), поэтому в фабрику передаём стабильную косвенность.
import { createApiClient, ApiError, type ApiRequestOptions } from '@shared/api-client';

let unauthorizedHandler: (() => void) | null = null;

export function registerUnauthorizedHandler(handler: () => void): void {
  unauthorizedHandler = handler;
}

const client = createApiClient({
  storageKey: 'access_token',
  onUnauthorized: () => unauthorizedHandler?.(),
});

export const apiRequest = client.apiRequest;
export const accessTokenStorage = client.tokenStorage;
export { ApiError };
export type { ApiRequestOptions };
